module.exports = __webpack_public_path__ + "static/media/buffet15.037d71f2.jpg";